
export  const Routes = {
  Landing: 'Landing',
  IdentityScreen: 'IdentityScreen',
  Home: 'Home',
  Login: 'Login',
  Dish: 'Dish',
  SignUpScreen: 'SignUpScreen',
  ConfirmSignUpScreen: 'ConfirmSignUpScreen',
  ConfirmSignUpWithPinScreen: 'ConfirmSignUpWithPinScreen',
  SignInScreen: 'SignInScreen',
  PostRecipeScreen: 'PostRecipeScreen',
  CreateDishScreen: 'CreateDishScreen',
  ConsumerPostNeed: 'ConsumerPostNeed',
  ProviderPostServices: 'ProviderPostServices',
  OfferHelp:'OfferHelp',
  ProviderGetMyServices:'ProviderGetMyServices',
  ForgotPassword:'ForgotPasswordScreen',
  ProviderAdvertiseForm:'ProviderAdvertiseForm',
  ConsumerFollowing:'ConsumerFollowing',
  ProviderDetails:'ProviderDetails',
  AdvertisePlaceholder:'AdvertisePlaceholder',
  ConsumerGetEatFromProvider:'ConsumerGetEatFromProvider',
  ConsumerGetLiveFromProvider:'ConsumerGetLiveFromProvider',
  ConsumerGetMoveFromProvider:'ConsumerGetMoveFromProvider',
  AllServices:'AllServices',
  AllMyAsks:'AllMyAsks',
  ProviderGetEatFromConsumer:'ProviderGetEatFromConsumer',
  ProviderGetLiveFromConsumer:'ProviderGetLiveFromConsumer',
  ProviderGetMoveFromConsumer:'ProviderGetMoveFromConsumer',
  ItemOffers:'ItemOffers',
}
